import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Tooltip } from '@mui/material';
import React, { useContext, useState } from 'react'
import globalStyles from './../../../../assets/styles/global.module.scss'
import popupStyles from './../../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import accordionStyles from "./../../../../assets/styles/componentStyles/chatbotStyles/chats.module.scss"
import { subChatbotDataInterface } from '../../../../models/axiosModel';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconsColor from '../../../../components/utility/iconsColor';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatDateAccordingToTimezoneUsingMoment } from '../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import moment from "moment";

interface subchatbotExecutionLogInterface {
    subChatbotExceutionLogData: subChatbotDataInterface
}

const SubChatbotExecutionLogData = (props: subchatbotExecutionLogInterface) => {
    const {subChatbotExceutionLogData} = props;
    const [copyText, setCopyText] = useState<string>("Copy");
    const {userDetail} = useContext(UserContext) as UserContextPayload

    const calculateTimeDifference = (rdata: any) => {

        const startTime = moment.utc(rdata?.ai_response?.created * 1000);
        const endTime = moment.utc(rdata?.timestamp);

        const duration = moment.duration(endTime.diff(startTime));

        // return `${duration.hours()}h ${duration.minutes()}m ${duration.seconds()}s`;
        return `${duration.seconds()}s`;
    }

    return (
        <Grid item className={accordionStyles.stepsDataPopupContainer}>
            <Grid container direction={"column"} gap={2}>
                <Grid item className={globalStyles.fullwidth} textAlign={"center"}>
                    <span className={popupStyles.popupTitleStyle}>Sub Chatbot Execution Logs</span>
                </Grid>
                <Grid item className={globalStyles.fullwidth}>
                    <Divider className={accordionStyles.dividerGlobalStyle} />
                </Grid>
                <Grid item className={accordionStyles.threadExecutionDrawersStyle}>
                    <Grid container gap={2}>
                        {subChatbotExceutionLogData && subChatbotExceutionLogData?.data && subChatbotExceutionLogData?.data?.length > 0 ?
                            subChatbotExceutionLogData?.data?.map((rdata: any, index: number) => (
                                <Accordion key={index} className={`${accordionStyles.agentAccordion} ${accordionStyles.transitionAccordion} ${accordionStyles.accordionDesignStyle}`}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />} 
                                        aria-controls="panel1-content"
                                        id="panel1-header" 
                                        sx={{minHeight: "45px !important"}}
                                    >
                                        <Grid container gap={"6px"} justifyContent={"space-between"}>
                                            <Grid item>
                                                <Grid container gap={"6px"}>
                                                    <Grid item className={accordionStyles.stepTextStyle}>
                                                        {`Execution Log ID: `}
                                                    </Grid>
                                                    <Grid item className={accordionStyles.stepTextValueStyle}>
                                                        {rdata?.sub_chatbot_execution_log_id || "-"}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item className={accordionStyles.stepTextStyle} paddingRight={"10px"}>
                                                <Grid container gap={1} alignItems={"center"}>
                                                    <Grid item className={globalStyles.displayFlexStyle}>
                                                        <CopyToClipboard text={JSON.stringify(rdata, null, 4)}>
                                                            <Tooltip
                                                                title={copyText}
                                                                onMouseLeave={() => setCopyText("Copy!")}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    setCopyText("Copied!");
                                                                }}
                                                            >
                                                                <Grid item className={globalStyles.displayFlexStyle}>
                                                                    <IconsColor iconName={"Copy"}
                                                                        fillColor={"black"}
                                                                        width={"15"} height={"15"} />
                                                                </Grid>
                                                            </Tooltip>
                                                        </CopyToClipboard>
                                                    </Grid>
                                                    <Grid item>
                                                        {/* {formatDateAccordingToTimezoneUsingMoment(rdata?.timestamp, userDetail.timezone_hour, "all")} */}
                                                        {calculateTimeDifference(rdata)}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            
                                        </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails
                                        className={`${accordionStyles.accordionDetailsStyle}`}
                                    >
                                        <Grid item xs={12} className={accordionStyles.jsonDataStyle}>
                                            <Grid container justifyContent={"space-between"} marginBlock={"5px 10px"} className={accordionStyles.stepTextStyle}>
                                                <Grid item>
                                                    Start Time: {formatDateAccordingToTimezoneUsingMoment(new Date(rdata?.ai_response?.created * 1000)?.toISOString(), userDetail.timezone_hour, "campaign")}
                                                </Grid>
                                                <Grid item>
                                                    End Time: {formatDateAccordingToTimezoneUsingMoment(rdata?.timestamp, userDetail.timezone_hour, "campaign")}
                                                </Grid>
                                            </Grid>
                                            <pre key={index} className={accordionStyles.jsonDataPreStyle}>
                                                {JSON.stringify(rdata, null, 4)}
                                            </pre>
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            ))
                            :
                            <Grid item className={accordionStyles.stepTextStyle}>
                                No Logs Found.
                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default SubChatbotExecutionLogData
